import {makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    faqContainer: {
        display: 'flex',
        width:'100%',
        flexDirection: 'column',
    },
    faqTitle: {
        fontSize: '2rem',
        fontWeight: 'bold'
    },
}));
